import { watch, type Ref } from "vue";

export const useAutoSave = <T>(
  data: Ref<T>,
  savefn: (data: T) => void,
  duration = 1000
) => {
  let saveTimeout: NodeJS.Timeout | null = null;

  const autoSave = () => {
    if (saveTimeout) clearTimeout(saveTimeout);

    saveTimeout = setTimeout(() => {
      savefn(data.value);
    }, duration);
  };

  watch(
    data,
    () => {
      autoSave();
    },
    {
      deep: true,
    }
  );
};
